import {useEffect} from 'react'
import {checkRunningTasks} from '../../../data/tasks.js'

export default function TaskListener() {
  useEffect(() => {
    checkRunningTasks()
  }, [])

  return null
}
